// extracted by mini-css-extract-plugin
export default {"wrap":"zU-z","subtitle":"AU-z","contentWrap":"BU-z","imgWrap":"CU-z","heading":"DU-z","copy":"EU-z"};